import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import PortalVue from 'portal-vue'
import i18n from './languages'
import router from './router'

import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/visualMap'
import lineTheme from './assets/echarts-themes/line.json'
import darkmapTheme from './assets/echarts-themes/darkmap.json'

import App from './App.vue'

const GA_ID = process.env.VUE_APP_GA_ID

echarts.registerTheme('line', lineTheme)
echarts.registerTheme('darkmap', darkmapTheme)

Vue.config.productionTip = false
if (GA_ID) {
  Vue.use(VueAnalytics, {
    id: GA_ID,
    router,
  })
}
Vue.use(PortalVue)

new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
